import { Host, h, } from "@stencil/core";
export class IdeLoader {
    constructor() {
        this.showWindow = false;
        this.showWrapper = false;
        this.loaderTitle = undefined;
        this.description = undefined;
        this.cancelLabel = undefined;
        this.cancelCallback = undefined;
        this.show = false;
        this.abortTime = 5000;
        this.container = undefined;
    }
    /*
  INDEX:
  1.OWN PROPERTIES
  2.REFERENCE TO ELEMENTS
  3.STATE() VARIABLES
  4.PUBLIC PROPERTY API | WATCH'S
  5.EVENTS (EMIT)
  6.COMPONENT LIFECYCLE EVENTS
  7.LISTENERS
  8.PUBLIC METHODS API
  9.LOCAL METHODS
  10.RENDER() FUNCTION
  */
    // 1.OWN PROPERTIES //
    /**
     * The transition speed for displaying/hiding the ch-window
     */
    showTransition = 200;
    timeoutReference;
    // 2. REFERENCE TO ELEMENTS //
    containerEl;
    showHandler(show) {
        const timeout = 50;
        if (show) {
            this.showWindow = true;
            setTimeout(() => {
                this.showWrapper = true;
            }, timeout);
        }
        else {
            this.showWrapper = false;
            setTimeout(() => {
                this.showWindow = false;
                this.loaderFinished.emit();
            }, this.showTransition);
        }
        if (show) {
            if (this.timeoutReference) {
                clearTimeout(this.timeoutReference);
            }
            this.timeoutReference = setTimeout(() => {
                this.show = false;
            }, this.abortTime);
        }
    }
    // 5.EVENTS (EMIT) //
    loaderFinished;
    // 6.COMPONENT LIFECYCLE EVENTS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    renderTitle = () => {
        return this.loaderTitle ? (h("gxg-title", { class: "loader__title", type: "title-04", alignment: "center" }, this.loaderTitle)) : null;
    };
    renderDescription = () => {
        return this.description ? (h("gxg-text", { class: "loader__description", type: "text-regular", textAlign: "center" }, this.description)) : null;
    };
    renderCancelButton = () => {
        return this.cancelLabel ? (h("gxg-button", { class: {
                [`loader__cancel-button`]: true,
                "loader__cancel-button--move-up": this.loaderTitle && !this.description,
            }, type: "secondary-text-icon", onClick: this.cancelProcess }, this.cancelLabel)) : null;
    };
    cancelProcess = () => {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
        clearTimeout(this.timeoutReference);
        this.show = false;
    };
    //  10.RENDER() FUNCTION //
    render() {
        return (h(Host, null, h("ch-window", { closeOnEscape: false, closeOnOutsideClick: false, container: this.container, hidden: !this.showWindow, modal: false, showFooter: false, showHeader: false, style: { "--show-transition": `${this.showTransition}ms` } }, h("div", { class: {
                [`loader__wrapper`]: true,
                "loader__wrapper--visible": this.showWrapper,
            }, part: "loader-wrapper" }, h("div", { class: "loader__spinner" }), h("div", { class: {
                "loader__content-wrapper": true,
                "loader__content-wrapper--hidden": !this.description && !this.loaderTitle && !this.cancelLabel,
            } }, this.renderTitle(), this.renderDescription(), this.renderCancelButton())))));
    }
    static get is() { return "gxg-ide-loader"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ide-loader.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ide-loader.css"]
        };
    }
    static get properties() {
        return {
            "loaderTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The loader title (optional)"
                },
                "attribute": "loader-title",
                "reflect": false
            },
            "description": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The loader description (optional)"
                },
                "attribute": "description",
                "reflect": false
            },
            "cancelLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The cancel button label (optional)"
                },
                "attribute": "cancel-label",
                "reflect": false
            },
            "cancelCallback": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "IdeLoaderCancelCallback",
                    "resolved": "() => void",
                    "references": {
                        "IdeLoaderCancelCallback": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/ide-loader/ide-loader.tsx",
                            "id": "src/components/ide-loader/ide-loader.tsx::IdeLoaderCancelCallback"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The cancel callback"
                }
            },
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It shows the loader"
                },
                "attribute": "show",
                "reflect": false,
                "defaultValue": "false"
            },
            "abortTime": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The time the loader will await before abort."
                },
                "attribute": "abort-time",
                "reflect": false,
                "defaultValue": "5000"
            },
            "container": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLElement",
                    "resolved": "HTMLElement",
                    "references": {
                        "HTMLElement": {
                            "location": "global",
                            "id": "global::HTMLElement"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The container element for the loader."
                }
            }
        };
    }
    static get states() {
        return {
            "showWindow": {},
            "showWrapper": {}
        };
    }
    static get events() {
        return [{
                "method": "loaderFinished",
                "name": "loaderFinished",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "show",
                "methodName": "showHandler"
            }];
    }
}
//# sourceMappingURL=ide-loader.js.map
